import React, { Component } from "react";
import View from "./view";
import { getFormsForMachine } from "../../../backend/machines";
import { withRouter } from "react-router-dom";
import "./index.css";
import { connect } from "react-redux";

class MachineHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machine_id: props.match.params.machineId,
      selectedMachine: {
        value: props.machine.machine_id,
        label: props.machine.machine_code
      },
      forms: [],
      loading: false
    };
    this._renderForm = this._renderForm.bind(this);
  }

  render() {
    return View.call(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { machine_id, code } = this.props.match.params;
    // code = (await getFormsForMachine(machine_id)).code
    if (prevProps.match.params.machine_id !== machine_id) {
      this.setState({ loading: true });
      this.setState({
        forms: await getFormsForMachine(machine_id),
        code: code,
        loading: false,
        // code : code
      });
    }
  }

  async componentDidMount() {
    const { machine_id } = this.props.match.params;
    this.setState({ loading: true });
    this.setState({
      forms: await getFormsForMachine(machine_id),
      loading: false,
      // code : code
    });
  }

  _renderForm(inspection, key) {
    const { machine_id} = this.props.match.params;
    return (
      <div
        key={key}
        className={`machine ${inspection.status !== null && inspection.status.replace(" ", "-")}`}
        onClick={this._navigate(
          `/machine-form/${machine_id}/${inspection.id}/`
        )}
      >
        <div className="id">{inspection.code}</div>
        <div className="status">{inspection.status}</div>
        <div className="created-at">{inspection.created_at}</div>
      </div>
    );
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    machine: state.selections.machine || { machine_code: "", machine_id: "" }
  };
};

export default withRouter(connect(mapStateToProps)(MachineHistory));



// WEBPACK FOOTER //
// ./src/screens/machines/machine-history/index.js